import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import ServiceContractLanding from './ServiceContractLanding';
import ServiceContractView from './ServiceContractView';

const ServiceContractDetailsPage = ({ params }) => {
  let breadcrumbs = params?.id && [
    SITE_PAGES.ALL_SERVICE_CONTRACTS,
    { ...SITE_PAGES.SC_DETAILS, text: params.id },
  ];

  return (
    <ServiceContractLanding
      title='Manage Service Contract'
      breadcrumbs={breadcrumbs}>
      <ServiceContractView editable params={params} />
    </ServiceContractLanding>
  );
};

ServiceContractDetailsPage.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default ServiceContractDetailsPage;
